let sentry: typeof import('@sentry/browser') | null = null;

export async function getSentry() {
  if (!sentry) {
    sentry = await import('@sentry/browser');
  }
  return sentry;
}

let sentryVue: typeof import('@sentry/vue') | null = null;

export async function getSentryVue() {
  if (!sentryVue) {
    sentryVue = await import('@sentry/vue');
  }
  return sentryVue;
}
